<div class="flex-col w-100 justify-stretch items-stretch">
	<h2 mat-dialog-title>{{title}} '{{propertyHeader}}'</h2>
	<mat-dialog-content>
		@if (canSeeAdminBidHistory) {
			<app-bidding-history-admin [propertyId]="id" [auctionIsLive]="propertyIsLive" [updateUponInit]="true" [auctionType]="auctionType"></app-bidding-history-admin>
		}
		@else {
			<!-- client users: masked bids of the public view, one tab per auction sequence, read-only -->
			<app-bidding-history-anonymized [propertyId]="id" [auctionType]="auctionType"></app-bidding-history-anonymized>
		}
	</mat-dialog-content>
	<mat-dialog-actions >
		<div class="flex-row spce-between items-center w-100 mt-3 p-2">
			<button mat-flat-button class="w-100" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
		</div>
		@if (canSeeAdminBidHistory) {<div class="text-xs">PropertyId: {{propertyId}} ({{id}}), AuctionId: {{auctionId}}</div>}
	</mat-dialog-actions>
</div>

